import FinalDetailsStep from '../../steps/FinalDetailsStep';
import { OnboardingNodeType, OnboardingStepType } from '../../steps/types';
import { OnboardingNode } from '../../types';

export const FINAL_DETAILS_NODE: OnboardingNode = {
  index: 0,
  key: OnboardingNodeType.FINAL_DETAILS,
  options: { countsTowardProgressBar: false, hideProgressBar: true },
  elements: [
    {
      uid: OnboardingStepType.FINAL_DETAILS,
      component: (
        <FinalDetailsStep
          uid={OnboardingStepType.FINAL_DETAILS}
          nodeType={OnboardingNodeType.FINAL_DETAILS}
          displayName=""
          actionButtonText="Next"
        />
      )
    }
  ]
};
